import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeftRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-chevrons-left-right-icon lucide-chevrons-left-right", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9 7-5 5 5 5" }), /* @__PURE__ */ React.createElement("path", { d: "m15 7 5 5-5 5" }));
const ForwardRef = forwardRef(SvgChevronLeftRight);
export default ForwardRef;
